import { MutableRefObject, SetStateAction } from "react";
import EventSuspense from "../suspense/EventSuspense";
import { SocialPostType } from "../../types";
import EventHeader from "./EventHeader";
import { Button } from "@/shared/ui/button.tsx";

type EventsProps = {
  isLoading: boolean,
  eventsData: SocialPostType[],
  page: number,
  setPage: React.Dispatch<SetStateAction<number>>,
  container: MutableRefObject<HTMLDivElement | null>,
  isInitial: MutableRefObject<boolean>,
  onInView: (id: string) => void,
  onSchedule: (id: number) => void
}

const Events = ({ eventsData, isLoading, container, page ,setPage, onInView, isInitial, onSchedule }: EventsProps) => {

  return (
    <div className="w-full md:w-2/3 lg:w-[46%] 2xl:w-[56%] 2xl:-ms-[8%] flex flex-col gap-2" >
      {isLoading && <EventSuspense />}
      <div className="flex flex-col gap-7" >
        {eventsData.map((event, index) => (
          <EventHeader
            eventIndex={index}
            container={container}
            isInitial={isInitial}
            onInView={onInView}
            event={event}
            onSchedule={onSchedule}
            key={event.event_id} />
        ))}
        {eventsData.length === 0 && (
          <div className="w-full font-poppins">No events here</div>
        )}
        <div className="w-full flex items-center justify-between">
          <Button 
            disabled={page === 1}
            onClick={() => {
            setPage(page => {
              if (page > 1) {
                return page - 1
              }
              return page
            })
          }} >Previous
          </Button>
          <Button 
            disabled={eventsData.length === 0}
            onClick={() => setPage(page => page + 1)}>
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Events;
